import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38fca963"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "file-btns" }
const _hoisted_3 = { class: "btns" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inputs" }, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "tool-bar"
}
const _hoisted_6 = { class: "tips-box" }
const _hoisted_7 = { class: "tips" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "pkg-col-box" }
const _hoisted_10 = { class: "pkg-text" }
const _hoisted_11 = { class: "pkg-text num" }
const _hoisted_12 = { class: "pkg-unit" }
const _hoisted_13 = { class: "pkg-text" }
const _hoisted_14 = { class: "pkg-text num" }
const _hoisted_15 = { class: "pkg-unit" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "将", -1))
const _hoisted_18 = { style: {"width":"300px"} }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "修改为", -1))
const _hoisted_20 = { style: {"width":"300px"} }
const _hoisted_21 = { class: "operation-col" }

import { Ref, computed, createVNode, onMounted, onUnmounted, ref, watch } from 'vue';
import { OioButton, OioInput, OioMessage, OioModal, OioNotification, OioSpin } from '@kunlun/vue-ui-antd';
import {
  ExclamationCircleOutlined,
  TagFilled,
  FullscreenOutlined,
  FullscreenExitOutlined,
  MinusCircleOutlined,
  PlusCircleOutlined
} from '@ant-design/icons-vue';
import { Modal } from 'ant-design-vue';
import { cloneDeep, debounce } from 'lodash-es';
import { http, getEasyImportTemplate, ModelCache, ModelFieldType } from '@kunlun/dependencies';
import { nextTick } from 'vue';
import { vxeTableRemoveZeroFormatter } from '../../../../utils/fotmatter';
import {querySimpleCodeList, queryWorkbook} from '../../../../api';
import { FormM2mMultiAfterSalesRefundsFieldWidget } from './FormM2mMultiAfterSalesRefundsFieldWidget';
import { clickUploadExcelFile, exportModelExcelFile } from '../../../../utils/excel';
import { useProductPackage } from '../../../../hooks';
import {queryPromotionType} from "@/custom-widget/MindMap/widgets/field/form/MindMap/services";

interface IProps {
  fetchData: (itemDetailStr: string) => Promise<any>;
  updateBatch: (rows: any[]) => Promise<any>;
  confirmReturnDetail: () => Promise<any>;
  setFormData: (formData: any) => void;
  _formData: any;
  getGqlMutationName: () => string;
  mountedProcessFlag: boolean;
  _instance: FormM2mMultiAfterSalesRefundsFieldWidget;
  actionBarActions: {
    showExportAction: boolean;
    showImportAction: boolean;
    showAddRowAction: boolean;
    showBatchUpdateAction: boolean;
    showBatchDeleteAction: boolean;
    showPriceSourceAction: boolean;
    showQuickAddAction: boolean;
    showERPCodeFilterInput: boolean;
  };
  addRowExpendCondition: string;
  showSpecificationTip: boolean;
  editApplyRefundUnitPrice: boolean;
  changeReasonAfter: () => () => void;
  showReverseNum: boolean;
  rModel: any;
  deleteRow: (string) => void;
  ERPCodeFilterString: string;
  ERPCodeFilterStringChange: (string) => void;
  originalEditTypeOptions: {
    label: string;
    value: any;
  }[];
  allerUpdatePrice: boolean|undefined;
}

interface SpecificationData {
  count: any;
  conversionRules: string;
  id: string;
  pcsCount: number;
  unitCode: string;
  unitName: string;
}


const __default__ = {
  name: 'AfterSalesRefunds'
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    fetchData: null,
    updateBatch: null,
    confirmReturnDetail: null,
    setFormData: null,
    _formData: null,
    getGqlMutationName: null,
    mountedProcessFlag: { type: Boolean },
    _instance: null,
    actionBarActions: null,
    addRowExpendCondition: null,
    showSpecificationTip: { type: Boolean },
    editApplyRefundUnitPrice: { type: Boolean },
    changeReasonAfter: null,
    showReverseNum: { type: Boolean, default: false },
    rModel: null,
    deleteRow: null,
    ERPCodeFilterString: null,
    ERPCodeFilterStringChange: null,
    originalEditTypeOptions: null,
    allerUpdatePrice: { type: [Boolean, null] }
  },
  setup(__props: any) {

const props = __props as { fetchData: (itemDetailStr: string) => Promise<any>, updateBatch: (rows: any[]) => Promise<any>, confirmReturnDetail: () => Promise<any>, setFormData: (formData: any) => void, _formData: any, getGqlMutationName: () => string, mountedProcessFlag: boolean, _instance: FormM2mMultiAfterSalesRefundsFieldWidget, actionBarActions: {
    showExportAction: boolean;
    showImportAction: boolean;
    showAddRowAction: boolean;
    showBatchUpdateAction: boolean;
    showBatchDeleteAction: boolean;
    showPriceSourceAction: boolean;
    showQuickAddAction: boolean;
    showERPCodeFilterInput: boolean;
  }, addRowExpendCondition: string, showSpecificationTip: boolean, editApplyRefundUnitPrice: boolean, changeReasonAfter: () => () => void, showReverseNum: boolean, rModel: any, deleteRow: (string) => void, ERPCodeFilterString: string, ERPCodeFilterStringChange: (string) => void, originalEditTypeOptions: {
    label: string;
    value: any;
  }[], allerUpdatePrice: boolean|undefined }



const { generateConvertRelationStr } = useProductPackage();

const priceTypeEnumList = ref<any>({
  EX_FACTORY_PRICE: '出厂价',
  PRICE: '一口价',
  REAL_PRICE: '实价',
  RETAIL_PRICE: '零售价'
});

const tableRef = ref<any>();
const errorTableRef = ref<any>();
const errorData = ref<any[]>([]);
const selectRecords = ref<any[]>([]);
const isAllChecked = ref(false);
const isIndeterminate = ref(false);
const searchVal = ref('');
const errorModal = ref<boolean>(false);
const reasonOptions = ref<any[]>([]);
const tips = ref('');
const addLoading = ref(false);
const tableLoading = ref(false);
const importLoading = ref(false);
const exportLoading = ref(false);
const confirmLoading = ref(false);
const dataSource = ref<any[]>([]);
const totalAmount = ref(0);
const editModalVisible = ref(false);
const editModalConfirmLoading = ref(false);
const editModalDataList = ref<any[]>([{ id: 0 }]);

const contentRef = ref();
const isFullscreen = ref(false);
const canshowTips = ref(true);
const simpleCodeOptions = ref<any[]>([]);
const simpleCodeList = ref<any>([]);
const promotionTypeEnumList = ref<any>({});

const onFullscreenChange = () => {
  isFullscreen.value = Boolean(document.fullscreenElement);
};
onMounted(() => {
  document.addEventListener('fullscreenchange', onFullscreenChange);
  querySimpleCodeList(props.rModel, "").then(
      (res) => {
        simpleCodeList.value = res;
        simpleCodeOptions.value = simpleCodeList.value.content.map((i) => ({label: i.simpleCode + "-" + i.description, value: i.id}));
        console.log(simpleCodeList);
        console.log(simpleCodeOptions);
      }
  );
  queryPromotionType(props.rModel).then(res=>{
    promotionTypeEnumList.value = res?.promotionTypeEnumList?.map((item) => {
      return { label: item.displayName, value: item.value };
    });
  });
});
onUnmounted(() => {
  document.removeEventListener('fullscreenchange', onFullscreenChange);
});

const getPopupContainer = (triggerNode: HTMLElement) => {
  let curNode = triggerNode;
  while (curNode) {
    if (curNode.id === 'ASR-content') {
      return curNode;
    }
    curNode = curNode.parentNode as HTMLElement;
  }
  return document.body;
};

const getModalContainer = () => {
  const container = document.getElementById('ASR-content');
  return container ?? document.body;
};

// 如果Widget中有传入选项，则取Widget的选项，否则取默认值（兼容品牌）
const originalEditTypeOptions: {
  label: string;
  value: any;
}[] = props.originalEditTypeOptions || [
  { label: '申请售后单价', value: 'applyRefundUnitPrice' },
  { label: '售后数量', value: 'applyReverseNum' },
  { label: '促销简码', value: 'promotionSimpleCode' },
  { label: '促销类型', value: 'policyPromotionType' }
];
const displayEditTypeOptions = computed(() => {
  type Writeable<T> = { -readonly [P in keyof T]: T[P] };
  const copy: any[] = cloneDeep(originalEditTypeOptions as Writeable<typeof originalEditTypeOptions>);
  copy.forEach((item) => {
    if (editModalDataList.value.some((data) => data.type === item.value)) {
      item.disabled = true;
    } else {
      item.disabled = false;
    }
  });
  return copy;
});

let count = 1;
const addEditModalRow = () => {
  editModalDataList.value.push({
    id: count++
  });
};
const removeEditModalRow = (id: number) => {
  editModalDataList.value = editModalDataList.value.filter((item) => item.id !== id);
};

const onSimpleCodeChange = async (value,row) => {
  debugger;
  // props.setTableEditStatus('OPEM')
  console.log('onSimpleCodeChange', value, row);
  row.promotionSimpleCodeObjId = value;
  const obj =  simpleCodeList.value.content.find(n=>n.id == value);
  console.log(obj);
  row.promotionSimpleCodeObj = obj;
  row.promotionSimpleCode = obj.simpleCode;
  // props.setTableEditStatus('CLOSED')
};

const applyBatchEdit = async () => {
  for (const { type, value, reason = '' } of editModalDataList.value) {
    if (!type) {
      continue;
    }
    // 未勾选则修改全部
    const changeAll = selectRecords.value.length === 0;
    for (const item of dataSource.value) {
      if (
        !changeAll &&
        // 未选中行不修改
        !selectRecords.value.some((row) => row?.id === item.id)
      ) {
        continue;
      }
      // 售后原因特殊赋值
      if (type === 'reason') {
        item[type] = props._formData.allReason?.find(item => item.reason === reason);
        continue;
      }
      if (type === 'promotionSimpleCode') {
        console.log(value);
        const obj =  simpleCodeList.value.content.find(n => n.id == value);
        item.promotionSimpleCodeObjId = value;
        item.promotionSimpleCodeObj = obj
        item.promotionSimpleCode = obj.simpleCode;
      }
      else if (type === 'policyPromotionType') {
        console.log(value);
        // const obj =  promotionTypeEnumList.value.content.find(n => n.value == value);
        item.policyPromotionType = value;
      } else {
        item[type] = value;
      }
    }
  }
  await nextTick();
  await changeRows(dataSource.value);
  await autoSource();
};

const onSubmitBatchEdit = async () => {
  editModalConfirmLoading.value = true;
  try {
    await applyBatchEdit();
    editModalDataList.value = [{ id: count++ }];
    editModalVisible.value = false;
  } finally {
    editModalConfirmLoading.value = false;
  }
};

const checkboxChangeEvent = () => {
  const $table = tableRef.value;
  if ($table) {
    isAllChecked.value = $table.isAllCheckboxChecked();
    isIndeterminate.value = $table.isAllCheckboxIndeterminate();
    selectRecords.value = $table.getCheckboxRecords();
  }
};

const beforeEditMethod = (scope) => {
  const isEmpty = !scope.row?.outCode;
  const hasReason = !!scope.row?.reason?.reason;
  // 业务编辑时不能编辑申请售后单价
  const allerUpdatePrice =scope.column.title !== '申请售后单价' || props.allerUpdatePrice !== false;
  return ['申请售后单价', '售后扣率', '包装规格', '申请售后数量'].includes(scope.column.title) && !isEmpty && hasReason && allerUpdatePrice;
};

const handleDelete = () => {
  Modal.confirm({
    title: '确认删除吗?',
    icon: createVNode(ExclamationCircleOutlined),
    onOk() {

      selectRecords.value.forEach((row) => {
        props.deleteRow && props.deleteRow(row.outCode);
      });

      dataSource.value = dataSource.value.filter((item) => !selectRecords.value.some((row) => row?.outCode === item.outCode));
      tableRef.value?.reloadData(dataSource.value);
      if (dataSource.value.length === 0) {
        totalAmount.value = 0;
      }
      checkboxChangeEvent();
    }
  });
};

const exportDataEvent = () => {
  try {
    exportLoading.value = true;
    // @ts-ignore
    const model = props._instance.runtimeSubviewContext.model;
    exportModelExcelFile(
      dataSource.value,
      {
        ...model,
        modelFields: model.modelFields.filter((field) => field.name !== 'reverseDiscount')
      },
      {
        filename: `申请退货退款商品明细_${Date.now()}.xlsx`,
        customFieldsParser: {
          outCode(val, index, field, row) {
            return { label: field.label + '(必填)', value: val };
          },
          saleUnitName(val, index, field, row) {
            return { label: field.label + '(必填)', value: val };
          },
          applyReverseNum(val, index, field, row) {
            return { label: field.label + '(必填)', value: val };
          },
          deliAriesItemSpecificationsProxyList(val, index, field, row) {
            return generateConvertRelationStr(val);
          },
          reason(val, index, field, row) {
            return { label: field.label + '(必填)', value: val?.reason ?? '' };
          },
          applyRefundUnitPrice(val, index, field, row) {
            return { label: field.label + '(单价)', value: val };
          }
          // reverseDiscount(val, index, field, row) {
          //   return { label: field.label + '(单价/扣率二选一)', value: val };
          // }
        }
      }
    );
  } catch (error) {
    throw error;
  } finally {
    exportLoading.value = false;
  }
};

const importDataEvent = () => {
  Modal.confirm({
    getContainer: () => document.getElementById('ASR-content')!,
    class: 'oio-modal',
    title: '提示',
    content: '请使用导出的表格进行导入，仅支持修改[申请售后单价]或[售后扣率]、售后数量！',
    icon: createVNode(ExclamationCircleOutlined),
    cancelText: '取消',
    okText: '开始导入',
    onOk: async () => {
      try {
        const arr = await clickUploadExcelFile();
        // @ts-ignore
        const model = props._instance.runtimeSubviewContext.model;
        const fields = cloneDeep(model.modelFields).filter((i) => !model.pks?.includes(i.data) && !i.invisible);
        fields.forEach((i) => {
          if (['applyRefundUnitPrice', 'reverseDiscount'].includes(i.data)) {
            i.label += '(单价)';
          } else if (['outCode', 'saleUnitName', 'applyReverseNum', 'reason'].includes(i.data)) {
            i.label += '(必填)';
          }
        });
        const importHeader = Object.keys(arr[0]);
        const modelHeader = fields.map((i) => i.label);
        if (!importHeader.every((key) => modelHeader.includes(key))) {
          OioNotification.error('错误', '导入数据表头不匹配，请使用导出的表格进行导入');
          return;
        }
        // 校验单价/扣率二选一
        const label1 = fields.find((i) => i.data === 'applyRefundUnitPrice')?.label;
        const label2 = fields.find((i) => i.data === 'reverseDiscount')?.label;
        if (arr.some((item) => item[label1!] && item[label2!])) {
          OioNotification.error('错误', '导入数据存在单价/扣率二选一错误，请修改后再次导入');
          return;
        }
        // 必填校验
        const requiredLabels = fields.filter((i) => ['outCode', 'saleUnitName', 'applyReverseNum', 'reason'].includes(i.data)).map((i) => i.label);
        const hasEmptyCell = arr.some((item) => {
          return requiredLabels.some((label) => !item[label!]);
        });
        if (hasEmptyCell) {
          OioNotification.error('错误', '导入数据缺少必填项，请修改后再次导入');
          return;
        }

        // 1通过扣率算单价，2的话通过单价算扣率，3修改原因
        const calcType = arr[0][label1!] ? 2 : 1;

        const rows = arr.map((item) => {
          const obj: any = {};
          obj.calcType = calcType;
          for (const k in item) {
            if (k === '包装规格') continue;
            const field = fields.find((field) => field.label === k);
            const key = field?.data;
            if (k === '售后原因(必填)') {
              obj[key!] = props._formData.allReason?.find((r) => r.reason === item[k]) ?? {};
            } else {
              const valMap = {
                [ModelFieldType.Float]: Number(item[k]),
                [ModelFieldType.Integer]: Number(item[k])
              };
              obj[key!] = typeof valMap[field!.ttype] === 'number' ? valMap[field!.ttype] : item[k];
            }
          }
          delete obj.priceType;
          return obj;
        });
        await changeRows(rows);
        autoSource();
      } catch (error) {
        console.error(error);
      } finally {
        importLoading.value = false;
        tableLoading.value = false;
      }
    }
  });
};

const insertEvent = async (row: any) => {
  if (dataSource.value.length && !dataSource.value[dataSource.value.length - 1].outCode) return;
  const $table = tableRef.value;
  if ($table) {
    const record = {};
    const { row: newRow } = await $table.insertAt(record, row);
    await $table.setEditCell(newRow, 'outCode');
    dataSource.value.push(newRow);
  }
};

const removeRow = ({ row, rowIndex }) => {
  Modal.confirm({
    title: '确认删除吗?',
    icon: createVNode(ExclamationCircleOutlined),
    async onOk() {
      tableLoading.value = true;
      try {
        dataSource.value.splice(rowIndex, 1);
        tableRef.value?.reloadData(dataSource.value);
        if (dataSource.value.length === 0) {
          totalAmount.value = 0;
        }
        checkboxChangeEvent();
        props.deleteRow && props.deleteRow(row.outCode);
      } finally {
        tableLoading.value = false;
      }
    }
  });
};

const autoSource = () => {
  if (canshowTips.value && props.showSpecificationTip) {
    Modal.confirm({
      title: '提示',
      content: '申请信息有更新，需要再次点击寻源。您可选择「我已知晓」，系统将会在下次变化继续提醒您。您也可以选择「不再提醒」，后续变化系统将帮您自动刷新。',
      okText: '不再提醒',
      cancelText: '我已知晓',
      onOk: async () => {
        canshowTips.value = false;
        onConfirm();
      }
    });
  } else {
    onConfirm();
  }
};

const queryData = async (str) => {
  searchVal.value = '';
  try {
    addLoading.value = true;
    tableLoading.value = true;

    let res = await props.fetchData(str);
    dataSource.value = res.initialProxySaleSkus ?? [];
    tableRef.value?.reloadData(dataSource.value);

    if (res.errMessages?.length) {
      tips.value = res.errMessages[0];
      const obj = {
        msg: res.errMessages[0]
      };
      errorData.value.unshift(...res.errMessages.map((msg) => ({ msg })));
      errorTableRef.value?.reloadData(errorData.value);
    }

    totalAmount.value = res.refundAmount;

    if (res?.isMerged) {
      OioMessage.info('添加时存在重复商品，商品数量已相加合并');
    }
  } finally {
    addLoading.value = false;
    tableLoading.value = false;
  }
};

const changeRows = async (rows: any[]) => {
  try {
    const res = await props.updateBatch(rows);
    if (res.errMessages?.length) {
      tips.value = res.errMessages[0];
      errorData.value.unshift(...res.errMessages.map((msg) => ({ msg })));
      errorTableRef.value?.reloadData(errorData.value);
      throw new Error(tips.value);
    } else {
      if (!dataSource.value?.length) {
        dataSource.value = res.initialProxySaleSkus ?? [];
      } else {
        res.initialProxySaleSkus?.forEach((j) => {
          dataSource.value.forEach((i, index) => {
            if (i.outCode === j.outCode) {
              Object.assign(i, j);
            }
          });
        });
      }
      tableRef.value?.reloadData(dataSource.value);
    }
    totalAmount.value = res.refundAmount;
    tableRef.value?.clearEdit();
  } catch (error) {
    throw error;
  }
};

const onChangeRow = async (scope) => {
  const { row, rowIndex, column } = scope;
  const copy = cloneDeep(dataSource.value);
  const sameRow = copy.find((r, i) => {
    return i !== rowIndex && r.outCode === row.outCode;
  });
  if (sameRow) {
    OioMessage.info('该商品已存在');
    throw new Error();
  }
  try {
    addLoading.value = true;
    tableLoading.value = true;
    dataSource.value.forEach((item, i) => {
      onSpecChange(i);
    });
    // 1通过扣率算单价，2的话通过单价算扣率，3修改原因
    const calcTypeMap = {
      售后扣率: 1,
      申请售后单价: 2,
      售后原因: 3
    };
    if (calcTypeMap[column.title]) {
      row.calcType = calcTypeMap[column.title];
    }
    await changeRows([row]);
    if (['申请售后单价', '包装规格', '售后扣率', '申请售后数量'].includes(column.title)) {
      autoSource();
    }
  } finally {
    addLoading.value = false;
    tableLoading.value = false;
  }
};

const onChangeReason = async (scope, val) => {
  scope.row.reason = props._formData.allReason?.find((item) => item.reason === val) ?? {};
  await onChangeRow(scope);

  props.changeReasonAfter?.();
};

const showErrorModal = () => {
  errorModal.value = true;
};

const onConfirm = async () => {
  confirmLoading.value = true;
  try {
    await props.confirmReturnDetail();
  } finally {
    confirmLoading.value = false;
  }
};

watch(
  dataSource,
  (value) => {
    props.setFormData(value);
  },
  { deep: true }
);
const stopWatchMountedFlag = watch(
  () => props.mountedProcessFlag,
  (value) => {
    if (value) {
      dataSource.value = props._formData.initialProxySaleSkus || [];
      stopWatchMountedFlag();
    }
  },
  { deep: true, immediate: true }
);
watch(
  () => props._formData.refundAmount,
  (value) => {
    totalAmount.value = value ?? 0;
  },
  { immediate: true }
);
watch(
  () => props._formData.reverseType,
  (val) => {
    if (!props.mountedProcessFlag) return;
    dataSource.value = [];
    tableRef.value.reloadData(dataSource.value);
    totalAmount.value = 0;
  }
);
watch(
  () => props._formData.allReason,
  (value) => {
    reasonOptions.value = value?.map((item) => ({ label: item.reason, value: item.reason })) ?? [];
  },
  {
    immediate: true
  }
);

const allItem = ref<any[]>([]);
const itemOptions = ref<any[]>([]);
const query = ref('');
const currentPage = ref(1);
const onItemSearch = async (q: string, coverData = true) => {
  query.value = q;
  if (!props._formData.buyerId) {
    OioMessage.error('请将买卖家信息填写完整!');
    return;
  }
  if (!props._formData.reverseType) {
    OioMessage.error('缺少售后类型数据!');
    return;
  }
  if (!props._formData.reverseDisChannel) {
    OioMessage.error('请将分销渠道填写完整!');
    return;
  }
  if (!query.value) {
    clearItemOptions();
    return;
  }
  const reverseDisChannel = cloneDeep(props._formData.reverseDisChannel as any);
  if (reverseDisChannel) {
    delete reverseDisChannel.__draftId;
    delete reverseDisChannel.META_BIT;
    delete reverseDisChannel._d_model;
  }

  const gql = `
        mutation {
          ${props.getGqlMutationName()} {
            searchItemsByCondition(
              data: {
                ${props.addRowExpendCondition || ''}
                buyerId: ${props._formData.buyerId}
                reverseType: ${props._formData.reverseType}
                reverseDisChannel: ${JSON.stringify(reverseDisChannel).replace(/"([a-zA-z_]+)":/g, (val, $1) => $1 + ':')}
                initialProxySaleSkus:[{searchKey: "${query.value}"}]
              }
              pagination: {
                currentPage: ${currentPage.value},
                size: 20
              }
            ) {
              name
              outCode
            }
          }
        }
      `;
  const res = await http.query('deliAriesCoreSeller', gql);
  const _allItem = (res.data[props.getGqlMutationName()] as any).searchItemsByCondition ?? [];
  const _itemOptions =
    _allItem.map((item) => ({
      label: item.name,
      value: item.outCode
    })) ?? [];

  if (coverData) {
    allItem.value = _allItem;
    itemOptions.value = _itemOptions;
  } else {
    allItem.value.push(..._allItem);
    itemOptions.value.push(..._itemOptions);
  }
};

const onItemSearchDebounce = debounce(onItemSearch, 200);

const clearItemOptions = () => {
  itemOptions.value = [];
  query.value = '';
  currentPage.value = 1;
};

const onSelectItemChange = async (outCode, scope) => {
  scope.row.outCode = outCode;
  try {
    await onChangeRow(scope);
  } catch (e) {
    scope.row.outCode = null;
    clearItemOptions();
    throw e;
  }
};

const loadMore = () => {
  currentPage.value += 1;
  onItemSearch(query.value, false);
};

const slipSelect = (event) => {
  const { scrollHeight, scrollTop, clientHeight } = event.target;
  // -1 兼容浏览器尺寸缩放
  if (scrollHeight - scrollTop - 1 <= clientHeight) {
    loadMore();
  }
};

const onReverseDiscountChange = async (value, scope) => {
  const regex = /^(\d*\.?\d{0,2}).*$/;
  const match = value.toString().match(regex);
  if (match) {
    await nextTick();
    scope.row.reverseDiscount = match[1];
  }
};

const downloadTemplate = async () => {
  const paramsMap = {
    RETURN_MONEY_GOODS: {
      model: await ModelCache.get('deli.aries.seller.DeliAriesSellerReverseDetailProxySaleSku'),
      isExport: false,
      name: '申请退货商品导入(退货退款)'
    },
    RETURN_TRANSFER: {
      model: await ModelCache.get('deli.aries.seller.DeliAriesSellerReverseDetailProxySaleSku'),
      isExport: false,
      name: '申请退货商品导入(退换货)'
    }
  };
  const params = paramsMap[props._formData.reverseType as keyof typeof paramsMap];
  const res = (await queryWorkbook(params.model!, params.isExport, params.name)).content;
  const urlObj: any = await getEasyImportTemplate(res[0].id);
  window.open(urlObj.redirectUri);
};

function useSpecifications(_dataSource: Ref<any[]>) {
  const specificationDataListList = ref<SpecificationData[][]>([]);

  const updateDataListList = () => {
    specificationDataListList.value = _dataSource.value.map((item) => {
      return generateSpecListByRowData(item);
    });
  };

  const generateSpecListByRowData = (row) => {
    if (!row?.deliAriesItemSpecificationsProxyList) {
      return [];
    }
    const options = row.deliAriesItemSpecificationsProxyList;
    let { applyReverseNum: itemNum } = row;
    const copy = cloneDeep(options);
    // 顺序大到小，方便计算，后续通过reverse改为小到大，方便展示
    copy.sort((a, b) => b.pcsCount - a.pcsCount || (b.unitName > a.unitName ? 1 : -1));
    return (
      copy
        .filter((item) => item.isEnabled !== false)
        .map((spe) => {
          const count = Math.floor(itemNum / spe.pcsCount);
          itemNum -= count * spe.pcsCount;
          spe.count = count;
          return spe;
        })
        .reverse() ?? []
    );
  };

  // FIXME: 包装规格更新性能
  watch(
    _dataSource,
    (val) => {
      updateDataListList();
    },
    { deep: true, immediate: true }
  );

  const onSpecChange = (rowIndex: number) => {
    const targetItemNum = specificationDataListList.value[rowIndex].reduce((acc, cur) => {
      return acc + cur.pcsCount * cur.count;
    }, 0);
    const row = _dataSource.value[rowIndex];
    if (!row?.deliAriesItemSpecificationsProxyList) {
      return;
    }
    const targetSpec = generateSpecListByRowData({
      ...row,
      applyReverseNum: targetItemNum
    });
    row.deliAriesItemSpecificationsProxyList = targetSpec;
    row.applyReverseNum = targetItemNum;
  };

  return {
    specificationDataListList,
    onSpecChange
  };
}

const { specificationDataListList, onSpecChange } = useSpecifications(dataSource);

const calcCellClassName = ({ row, rowIndex, $rowIndex, column, columnIndex, $columnIndex }) => {
  if (['包装规格'].includes(column.title)) {
    return 'toid-no-padding-cell';
  }
};

const applyReverseNumChange = (scope, val) => {
  scope.row.applyReverseNum = val;
};

const ERPCodeFilterClick = () => {
  if (props.ERPCodeFilterString === '') {
    tableRef.value.reloadData(dataSource.value);
    return;
  }
  const ERPCodeList = props.ERPCodeFilterString.split(' ');
  const tableData = dataSource.value;
  const filterRows = tableData.filter(row => ERPCodeList.includes(row.outCode));
  tableRef.value.reloadData(filterRows);
};


return (_ctx: any,_cache: any) => {
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_vxe_pager = _resolveComponent("vxe-pager")!

  return (_openBlock(), _createElementBlock("div", {
    class: "content",
    ref_key: "contentRef",
    ref: contentRef,
    id: "ASR-content"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (__props.actionBarActions.showExportAction)
            ? (_openBlock(), _createBlock(_unref(OioButton), {
                key: 0,
                type: "primary",
                onClick: exportDataEvent
              }, {
                default: _withCtx(() => [
                  _createTextVNode("导出")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (__props.actionBarActions.showImportAction)
            ? (_openBlock(), _createBlock(_unref(OioButton), {
                key: 1,
                type: "primary",
                onClick: importDataEvent,
                loading: importLoading.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode("导入 ")
                ]),
                _: 1
              }, 8, ["loading"]))
            : _createCommentVNode("", true),
          (__props.actionBarActions.showAddRowAction)
            ? (_openBlock(), _createBlock(_unref(OioButton), {
                key: 2,
                type: "primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (insertEvent(-1)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("添加下一行 ")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (__props.actionBarActions.showBatchUpdateAction)
            ? (_openBlock(), _createBlock(_unref(OioButton), {
                key: 3,
                type: "primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (editModalVisible.value = true))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 批量修改 ")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (__props.actionBarActions.showBatchDeleteAction)
            ? (_openBlock(), _createBlock(_unref(OioButton), {
                key: 4,
                type: "primary",
                bizStyle: "danger",
                disabled: !selectRecords.value.length,
                onClick: handleDelete
              }, {
                default: _withCtx(() => [
                  _createTextVNode("批量删除 ")
                ]),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true),
          (__props.actionBarActions.showPriceSourceAction)
            ? (_openBlock(), _createBlock(_unref(OioButton), {
                key: 5,
                type: "primary",
                bizStyle: "danger",
                onClick: onConfirm,
                loading: confirmLoading.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode("价格寻源 ")
                ]),
                _: 1
              }, 8, ["loading"]))
            : _createCommentVNode("", true),
          (__props.actionBarActions.showERPCodeFilterInput)
            ? (_openBlock(), _createBlock(_unref(OioInput), {
                key: 6,
                value: __props.ERPCodeFilterString,
                onChange: __props.ERPCodeFilterStringChange,
                placeholder: "请输入ERP编码，用空格分隔"
              }, null, 8, ["value", "onChange"]))
            : _createCommentVNode("", true),
          (__props.actionBarActions.showERPCodeFilterInput)
            ? (_openBlock(), _createBlock(_unref(OioButton), {
                key: 7,
                type: "primary",
                onClick: ERPCodeFilterClick
              }, {
                default: _withCtx(() => [
                  _createTextVNode("搜索 ")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _hoisted_4
      ]),
      (__props.actionBarActions.showQuickAddAction)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_unref(OioInput), {
              value: searchVal.value,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((searchVal).value = $event)),
              onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (queryData(searchVal.value)), ["enter"])),
              placeholder: "请粘贴SAP编码、下单单位、申请售后数量、售后扣率、售后原因",
              style: {"width":"400px"}
            }, null, 8, ["value"]),
            _createVNode(_unref(OioButton), {
              type: "primary",
              loading: addLoading.value,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (queryData(searchVal.value)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("快速添加")
              ]),
              _: 1
            }, 8, ["loading"]),
            _withDirectives(_createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(ExclamationCircleOutlined), { style: {"font-size":"16px","color":"var(--oio-error-color)"} }),
              _createElementVNode("span", _hoisted_7, _toDisplayString(tips.value), 1)
            ], 512), [
              [_vShow, tips.value]
            ]),
            _withDirectives(_createVNode(_unref(OioButton), { onClick: showErrorModal }, {
              default: _withCtx(() => [
                _createTextVNode(" 更多信息")
              ]),
              _: 1
            }, 512), [
              [_vShow, errorData.value.length]
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      _createVNode(_unref(OioSpin), { loading: tableLoading.value }, {
        default: _withCtx(() => [
          _createVNode(_component_vxe_table, {
            border: "",
            "header-align": "center",
            ref_key: "tableRef",
            ref: tableRef,
            height: "400",
            "keep-source": "",
            "column-config": { resizable: true },
            data: dataSource.value,
            "edit-config": { trigger: 'click', mode: 'cell', beforeEditMethod: beforeEditMethod },
            "scroll-y": { enabled: true, gt: 0 },
            "row-config": { height: 80 },
            "cell-class-name": calcCellClassName,
            onCheckboxChange: checkboxChangeEvent,
            onCheckboxAll: checkboxChangeEvent,
            onEditClosed: _cache[9] || (_cache[9] = (scope) => _ctx.$nextTick(() => onChangeRow(scope)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_vxe_column, {
                type: "checkbox",
                fixed: "left",
                width: "50",
                align: "center"
              }),
              _createVNode(_component_vxe_column, {
                type: "seq",
                title: "行号",
                fixed: "left",
                width: "50",
                align: "center"
              }),
              _createVNode(_component_vxe_column, {
                field: "outCode",
                title: "ERP商品编码",
                "min-width": "250"
              }, {
                default: _withCtx((scope) => [
                  (scope.row.outCode)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(scope.row.outCode), 1))
                    : (_openBlock(), _createBlock(_component_a_select, {
                        key: 1,
                        class: "oio-select",
                        "dropdown-class-name": "oio-select-dropdown",
                        getPopupContainer: getPopupContainer,
                        "show-search": "",
                        placeholder: "货号、ERP商品编码、商品名称",
                        style: {"width":"100%"},
                        "default-active-first-option": false,
                        "show-arrow": false,
                        "filter-option": false,
                        "not-found-content": null,
                        options: itemOptions.value,
                        onChange: (outCode) => onSelectItemChange(outCode, scope),
                        onSearch: _unref(onItemSearchDebounce),
                        onBlur: clearItemOptions,
                        onFocus: clearItemOptions,
                        onPopupScroll: slipSelect
                      }, null, 8, ["options", "onChange", "onSearch"]))
                ]),
                _: 1
              }),
              _createVNode(_component_vxe_column, {
                field: "itemName",
                title: "商品名称",
                width: "200"
              }),
              _createVNode(_component_vxe_column, {
                field: "itemNumber",
                title: "货号",
                width: "100"
              }),
              _createVNode(_component_vxe_column, {
                field: "characteristics",
                title: "产品特性",
                width: "100"
              }),
              _createVNode(_component_vxe_column, {
                field: "priceType",
                title: "价格类型",
                width: "100"
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("span", null, _toDisplayString(priceTypeEnumList.value[row.priceType]), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_vxe_column, {
                field: "externalMaterialGroup",
                title: "外部物料组",
                width: "100"
              }),
              _createVNode(_component_vxe_column, {
                field: "policyPromotionType",
                title: "促销类型",
                width: "200"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_a_select, {
                    class: "oio-select",
                    "dropdown-class-name": "oio-select-dropdown",
                    value: scope.row.policyPromotionType,
                    "onUpdate:value": ($event: any) => ((scope.row.policyPromotionType) = $event),
                    placeholder: "请选择促销类型",
                    allowClear: "",
                    defaultActiveFirstOption: false,
                    options: promotionTypeEnumList.value
                  }, null, 8, ["value", "onUpdate:value", "options"])
                ]),
                _: 1
              }),
              _createVNode(_component_vxe_column, {
                field: "promotionSimpleCodeObj",
                title: "促销简码",
                width: "100"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_a_select, {
                    class: "oio-select",
                    "dropdown-class-name": "oio-select-dropdown",
                    getPopupContainer: getPopupContainer,
                    placeholder: "请选择",
                    style: {"width":"100%"},
                    "default-active-first-option": false,
                    allowClear: "",
                    options: simpleCodeOptions.value,
                    showSearch: "",
                    optionFilterProp: "label",
                    value: scope.row.promotionSimpleCodeObjId,
                    "onUpdate:value": ($event: any) => ((scope.row.promotionSimpleCodeObjId) = $event),
                    onChange: (val) => onSimpleCodeChange(val, scope.row)
                  }, null, 8, ["options", "value", "onUpdate:value", "onChange"])
                ]),
                _: 1
              }),
              _createVNode(_component_vxe_column, {
                field: "minMarketPrice",
                title: "出厂价",
                width: "150",
                formatter: _unref(vxeTableRemoveZeroFormatter)
              }, null, 8, ["formatter"]),
              _createVNode(_component_vxe_column, {
                field: "saleUnitName",
                title: "单位",
                width: "100"
              }),
              _createVNode(_component_vxe_column, {
                field: "actualUnitPrice",
                title: "成交单价",
                width: "200",
                formatter: _unref(vxeTableRemoveZeroFormatter)
              }, null, 8, ["formatter"]),
              _createVNode(_component_vxe_column, {
                field: "applyRefundUnitPrice",
                title: "申请售后单价",
                width: "200",
                formatter: _unref(vxeTableRemoveZeroFormatter),
                "edit-render": __props.editApplyRefundUnitPrice ? { autofocus: 'input', placeholder: '请点击输入' } : undefined
              }, {
                edit: _withCtx((scope) => [
                  _createVNode(_component_a_input_number, {
                    class: "oio-input-number",
                    value: scope.row.applyRefundUnitPrice,
                    "onUpdate:value": ($event: any) => ((scope.row.applyRefundUnitPrice) = $event),
                    min: 0,
                    style: {"width":"110px"},
                    onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (tableRef.value?.clearEdit()), ["enter"])),
                    controls: false
                  }, null, 8, ["value", "onUpdate:value"])
                ]),
                _: 1
              }, 8, ["formatter", "edit-render"]),
              _createVNode(_component_vxe_column, {
                title: "包装规格",
                "edit-render": { autofocus: 'input', placeholder: '请点击输入' },
                width: "300"
              }, {
                default: _withCtx(({ row, rowIndex }) => [
                  _createElementVNode("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(specificationDataListList)[rowIndex], (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "pkg-input-col",
                        key: item.unitCode
                      }, [
                        _createElementVNode("div", _hoisted_10, _toDisplayString(item.unitName ?? ''), 1),
                        _createElementVNode("div", _hoisted_11, _toDisplayString(item.count ?? ''), 1),
                        _createElementVNode("div", _hoisted_12, "x" + _toDisplayString(item.pcsCount ?? 0) + "PCS", 1)
                      ]))
                    }), 128))
                  ])
                ]),
                edit: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: "pkg-col-box",
                    onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (tableRef.value?.clearEdit()), ["self","stop"]))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(specificationDataListList)[scope.rowIndex], (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "pkg-input-col",
                        key: item.unitCode
                      }, [
                        _createElementVNode("div", _hoisted_13, _toDisplayString(item.unitName), 1),
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_a_input, {
                            value: item.count,
                            onChange: (e) => (item.count = Number(String(e.target.value).replace(/[^0-9]/g, ''))),
                            style: {"width":"100%"},
                            onKeyup: _cache[6] || (_cache[6] = _withKeys(($event: any) => (tableRef.value?.clearEdit()), ["enter"]))
                          }, null, 8, ["value", "onChange"])
                        ]),
                        _createElementVNode("div", _hoisted_15, "x" + _toDisplayString(item.pcsCount ?? 0) + "PCS", 1)
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              }),
              (__props.showReverseNum)
                ? (_openBlock(), _createBlock(_component_vxe_column, {
                    key: 0,
                    field: "applyReverseNum",
                    title: "申请售后数量",
                    width: "200",
                    formatter: _unref(vxeTableRemoveZeroFormatter),
                    "edit-render": { autofocus: 'input', placeholder: '请点击输入' }
                  }, {
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(scope.row.applyReverseNum), 1)
                    ]),
                    edit: _withCtx((scope) => [
                      _createVNode(_component_a_input_number, {
                        value: scope.row.applyReverseNum,
                        onChange: (val)=>applyReverseNumChange(scope,val),
                        onKeyup: _cache[8] || (_cache[8] = _withKeys(($event: any) => (tableRef.value?.clearEdit()), ["enter"]))
                      }, null, 8, ["value", "onChange"])
                    ]),
                    _: 1
                  }, 8, ["formatter"]))
                : _createCommentVNode("", true),
              _createVNode(_component_vxe_column, {
                field: "reverseDiscount",
                title: "售后扣率",
                width: "200",
                formatter: _unref(vxeTableRemoveZeroFormatter)
              }, null, 8, ["formatter"]),
              _createVNode(_component_vxe_column, {
                field: "applyRefundAmount",
                title: "申请退款金额",
                width: "200",
                formatter: _unref(vxeTableRemoveZeroFormatter)
              }, null, 8, ["formatter"]),
              _createVNode(_component_vxe_column, {
                title: "售后原因",
                width: "180"
              }, {
                default: _withCtx((scope) => [
                  (scope.row.outCode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createVNode(_component_a_select, {
                          value: scope.row?.reason?.reason,
                          options: reasonOptions.value,
                          getPopupContainer: getPopupContainer,
                          onChange: (val) => onChangeReason(scope, val)
                        }, null, 8, ["value", "options", "onChange"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_vxe_column, {
                field: "assemblyItemDisplay",
                title: "关联子件",
                width: "300",
                "show-overflow": ""
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(row.assemblyItemDisplay), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_vxe_column, {
                title: "操作",
                fixed: "right",
                width: "80"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_unref(OioButton), {
                    type: "link",
                    danger: "",
                    onClick: ($event: any) => (removeRow(scope))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("删除")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data", "edit-config"]),
          _createVNode(_component_vxe_pager, {
            perfect: "",
            total: dataSource.value?.length,
            layouts: ['Total']
          }, null, 8, ["total"])
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _createVNode(_unref(OioModal), {
      visible: errorModal.value,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((errorModal).value = $event)),
      title: "提示信息",
      width: 600
    }, {
      default: _withCtx(() => [
        _createVNode(_component_vxe_table, {
          "header-align": "center",
          border: "",
          data: errorData.value,
          "max-height": 400,
          ref_key: "errorTableRef",
          ref: errorTableRef
        }, {
          default: _withCtx(() => [
            _createVNode(_component_vxe_column, {
              type: "seq",
              width: "60"
            }),
            _createVNode(_component_vxe_column, {
              field: "msg",
              title: "提示信息"
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(OioModal), {
      visible: editModalVisible.value,
      "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((editModalVisible).value = $event)),
      title: "批量修改",
      width: "medium",
      "get-trigger-container": getModalContainer
    }, {
      footer: _withCtx(() => [
        _createVNode(_unref(OioButton), {
          onClick: _cache[11] || (_cache[11] = ($event: any) => (editModalVisible.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_unref(OioButton), {
          type: "primary",
          onClick: onSubmitBatchEdit,
          loading: editModalConfirmLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(editModalDataList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "edit-row",
            key: item.id
          }, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_a_select, {
                class: "oio-select",
                "dropdown-class-name": "oio-select-dropdown",
                value: item.type,
                "onUpdate:value": ($event: any) => ((item.type) = $event),
                placeholder: "请选择",
                style: {"width":"100%"},
                "default-active-first-option": false,
                options: _unref(displayEditTypeOptions),
                getPopupContainer: getPopupContainer
              }, null, 8, ["value", "onUpdate:value", "options"])
            ]),
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              (['applyRefundUnitPrice', 'applyReverseNum'].includes(item.type))
                ? (_openBlock(), _createBlock(_component_a_input_number, {
                    key: 0,
                    class: "oio-input-number",
                    value: item.value,
                    "onUpdate:value": ($event: any) => ((item.value) = $event),
                    min: 0,
                    style: {"width":"100%"},
                    controls: false
                  }, null, 8, ["value", "onUpdate:value"]))
                : _createCommentVNode("", true),
              (['reason'].includes(item.type))
                ? (_openBlock(), _createBlock(_component_a_select, {
                    key: 1,
                    class: "oio-select",
                    "dropdown-class-name": "oio-select-dropdown",
                    placeholder: "请选择原因",
                    style: {"width":"100%"},
                    "default-active-first-option": false,
                    value: item.reason,
                    "onUpdate:value": ($event: any) => ((item.reason) = $event),
                    options: reasonOptions.value,
                    getPopupContainer: getPopupContainer
                  }, null, 8, ["value", "onUpdate:value", "options"]))
                : (item.type && ['promotionSimpleCode'].includes(item.type))
                  ? (_openBlock(), _createBlock(_component_a_select, {
                      key: 2,
                      class: "oio-select",
                      "dropdown-class-name": "oio-select-dropdown",
                      getPopupContainer: getPopupContainer,
                      placeholder: "不修改",
                      style: {"width":"100%"},
                      "default-active-first-option": false,
                      options: simpleCodeOptions.value,
                      showSearch: "",
                      optionFilterProp: "label",
                      value: item.value,
                      "onUpdate:value": ($event: any) => ((item.value) = $event)
                    }, null, 8, ["options", "value", "onUpdate:value"]))
                  : (item.type && ['policyPromotionType'].includes(item.type))
                    ? (_openBlock(), _createBlock(_component_a_select, {
                        key: 3,
                        class: "oio-select",
                        "dropdown-class-name": "oio-select-dropdown",
                        getPopupContainer: getPopupContainer,
                        placeholder: "不修改",
                        style: {"width":"100%"},
                        "default-active-first-option": false,
                        options: promotionTypeEnumList.value,
                        showSearch: "",
                        optionFilterProp: "label",
                        value: item.value,
                        "onUpdate:value": ($event: any) => ((item.value) = $event)
                      }, null, 8, ["options", "value", "onUpdate:value"]))
                    : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _withDirectives(_createVNode(_unref(MinusCircleOutlined), {
                onClick: ($event: any) => (removeEditModalRow(item.id))
              }, null, 8, ["onClick"]), [
                [_vShow, editModalDataList.value.length > 1]
              ]),
              _withDirectives(_createVNode(_unref(PlusCircleOutlined), { onClick: addEditModalRow }, null, 512), [
                [_vShow, index === editModalDataList.value.length - 1 && index !== _unref(displayEditTypeOptions).length - 1]
              ])
            ])
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["visible"])
  ], 512))
}
}

})